import React from 'react';
import Link from 'next/link';
import Icon from '@components/common/assets';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Banner3 = () => {
  return (
    <div className={cx('commonBox')}>
      <div className={cx('reviewInner')}>
        <div className={cx('reviewBox')}>
          <span className={cx('desc')}>
            자소서, 지원서 없이 글로벌 IT 기업에 합격한
            <br />
            김상동님의 합격 비법은?
          </span>

          <div className={cx('review')}>
            <span className={cx('import')}>JOBDA Matching 큰 특징은 스펙없이 역량만으로 취업이 가능</span>
            하다는 점인 것 같은데요.
            <br />
            <span className={cx('import')}>프로필은 인사 담당자들이 관심 가질 수 있도록 최대한 자세히 작성 하는</span>
            것이 좋습니다.
            <br />
            그래서 프로필 항목들을 빠짐없이 작성하려 노력했습니다.
            <br />
            이렇게 하니 확실히
            <span className={cx('import')}>매칭 제안도 많이 오고 합격률도 높아진 걸 느낄 수 있었어요.</span>
          </div>

          <div className={cx('subText')}>*합격후기 중 일부 발췌 및 수정</div>

          <Link className={cx('btnBasic')} href={'https://www.jobda.im/info/395'} target="_blank">
            <span className={cx('title')}>취업 합격후기 풀버전 확인</span>
            <Icon name="arrowRightLight" width={32} height={32} fill={Colors.C_JOBDA_BLACK} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Banner3;
